export default __webpack_public_path__ + "static/media/a011-011.69b37387.jpg";